module.exports = __webpack_public_path__ + "media/icons/offer-details-manual@2x-6e9fbf63.png";